import {useContext} from "react";
import {GraphQLClientContext, GraphQLClientContextType} from "./GraphQLClientContext";


export default function useGraphQLClient() {
    const {
        client
    } = useContext<GraphQLClientContextType>(GraphQLClientContext);
    return client;
}
